import { httpAPI } from "@/api/httpAPI";
const Uptime = 15;

const isOutdated = (moment, sync, uptime) => {
    let now = moment(Date.now());
    let syncTime = moment(sync);
    return moment.duration(now.diff(syncTime)).asMinutes() > uptime;
}; 

export default {
    namespaced: true,
    state: () => ({
        protocolResolutionAuthors: [],
        protocolResolutionAuthorsSyncAt: 0,

        сacheTimeInMinutes: 5,
    }),
    mutations:
    {
        SET_PROTOCOLRESOLITIONSAUTHORS (state, payload)
        {
            state.protocolResolutionAuthors = payload;
            state.protocolResolutionAuthorsSyncAt = Date.now()
        },
    },
    actions:
    {
        async getProtocolResolutionAuthors({ commit, state }) {
            
            try {
                if (!state.protocolResolutionAuthors || (Array.isArray(state.protocolResolutionAuthors) && state.protocolResolutionAuthors.length == 0) || isOutdated(this._vm.$moment, state.protocolResolutionAuthorsSyncAt, Uptime)){
                    let filter = {
                        DocType: "Avrora.Objects.Modules.Docflow.DocflowObjects.ProtocolDocument",
                        DocumentTypeC4: "3",
                        IsInnerOrder: false,
                        GetProtocolResolutionAuthors: true
                    };
                    let response = await httpAPI({
                        url: `/api/orders/list?collection=ProtocolsActItems&filter=${JSON.stringify(filter)}`,
                        method: 'GET'
                    });
                    commit('SET_PROTOCOLRESOLITIONSAUTHORS', response?.data?.Payload?.data ?? []);
                }
            }
            catch (error) {
                console.error('Ошибка обновления списка авторов поручений');
            }
            return state.protocolResolutionAuthors;
        },
    },
    getters:
    {
    }
}